import getScriptBaseUrl from 'owa-session-store/lib/actions/getScriptBaseUrl';
import { getSessionId } from 'owa-analytics/lib/LazyAnalytics';
import { getClientId, getBackend } from 'owa-config';

export default function() {
    return {
        UserAgent: window.navigator.userAgent,
        ScriptSource: getScriptBaseUrl(),
        SessionId: getSessionId(),
        ClientId: getClientId(),
        ClientServer: window.bootstrapDiagnostics.server,
        BEServer: getBackend(),
    };
}
